/**
 * 手机号授权
 */
import authUtils from '../authUtils';

const { DEFAULT_PHONE_OFFICIAL_ACCOUNTS_ID } = authUtils.config;
const readerCenterApi = authUtils.readerCenterApi;

class PhoneNumAuthorize {
  constructor({
    query,
    snsapiBase,
    defaultAuthorize
  }) {
    this.query = query || {};
    this.snapsis = snsapiBase || false;
    this.defaultAuthorize = defaultAuthorize || false; // 是否需要进入时授权
  }

  checkLogged() {
    const { wechatUserId, userType } = authUtils.getCookieUser();
    return !!wechatUserId && userType === authUtils.CONSTANT.USER_TYPE_REGULAR;
  }

  checkOpenid() {
    return !!this.query.openid;
  }

  getByOpenid() {
    const data = {
      openId: this.query.openid,
      officialAccountsId: DEFAULT_PHONE_OFFICIAL_ACCOUNTS_ID
    };
    return readerCenterApi.getUserInfoByOpenId(data);
  }

  /**
   * 进入默认授权
   */
  enterAuthorize() {
    return this.defaultAuthorize;
  }

  checkCode() {
    return !!this.query.auth_code;
  }

  getByCode() {
    return new Promise(function(resolve, reject) {

    });
  }

  //根据手机号获取用户信息
  getByPhoneNum= async ({ phone, validate, success, error }) => {
    try {
      let json = await readerCenterApi.phoneAuthorizeUser({ phone, validate });
      authUtils.saveCookieUser(json);
      success && success(json);
    } catch(err) {
      error && error(err);
    }
  }

  /**
   * 发起授权
   */
  forward() {
    //重定向到微信授权界面
    // const baseUrl = `${window.location.origin}/rayh5/auth/loginphone`;
    // return window.location = baseUrl;
  }

  static getAuthorizeUrl() {
    const href = window.location.href,
      search = window.location.search;
    if(search.indexOf('code') > -1) {
      const query = authUtils.params2json(search.slice(1));
      delete query.auth_code;
      delete query.scope;
      delete query.app_id;
      return (
        window.location.origin +
        window.location.pathname +
        '?' +
        authUtils.json2params(query)
      );
    } else {
      return href;
    }
  }
}

export default PhoneNumAuthorize;
